module.exports = __webpack_public_path__ + "static/img/02560_4.776fd6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/02560_4.jpg
// module id = dOsA
// module chunks = 1